import {HttpErrorResponse, HttpInterceptorFn} from '@angular/common/http';
import {inject} from "@angular/core";
import {TokenStoreService} from "../../services/token/token-store.service";
import {catchError} from "rxjs/operators";
import {throwError} from "rxjs";

export const httpTokenInterceptor: HttpInterceptorFn = (req, next) => {

  const tokenService = inject(TokenStoreService);

  const token = tokenService.getToken();
  if (token.accessToken) {
    req = req.clone({
      setHeaders: {
        Authorization: `Bearer ${token.accessToken}`,
      },
    });
  }

  return next(req)
    .pipe(catchError((e: HttpErrorResponse) => {
      if (e.status === 401) {
        tokenService.logout();
      }
      // const errorMessages = e?.error?.errorMessages ?? [];
      // const errorMessage = errorMessages.length > 0 ? errorMessages[0] : e.error?.message || e.statusText;
      return throwError(() => e);
    }));
};
